/* TODO: t() */
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Link } from 'react-router-dom';

import LoadingIndicator from './uiold/LoadingIndicator';
import { Page, Separator, Text } from './uiold';
import connectData, { ConnectedProps } from '../support/connectData';

function VendorChangesList(props: FullProps) {
  const { isLoading, vendors } = props;
  let vendorsList = vendors?.list.filter(
    (vendor) =>
      vendor.pendingFieldChanges && vendor.pendingFieldChanges.length > 0,
  );

  let pageTitle = 'Pending Vendor Change Requests';
  if (isLoading) {
    return (
      <Page>
        <Page.Header title={pageTitle} showSeparator={false} />
        <Separator />
        <LoadingIndicator />
      </Page>
    );
  }
  if (!vendorsList || vendorsList?.length === 0) {
    return (
      <Page>
        <Page.Header title={pageTitle} showSeparator={false} />
        <Separator style={{ marginBottom: 20 }} />
        <View style={{ padding: 20 }}>
          <Text style={styles.vendorItem}>
            No Vendors are currently awaiting approval of changes
          </Text>
        </View>
      </Page>
    );
  }

  return (
    <Page>
      <Page.Header title={pageTitle} showSeparator={false} />
      <Separator style={{ marginBottom: 20 }} />
      <View style={styles.vendorList}>
        {vendorsList.map((vendor) => {
          return (
            <Text key={`vendor-${vendor.id}`} style={styles.vendorItem}>
              <Link to={`/vendor-change/${vendor.id}`}>
                <Text>{`${vendor.name} - ${vendor.contact}`} </Text>
              </Link>
            </Text>
          );
        })}
      </View>
    </Page>
  );
}

const styles = StyleSheet.create({
  vendorList: {},
  vendorItem: {
    marginVertical: 8,
  },
});

const connector = connectData()(() => ({
  vendors: { dataStoreKey: 'vendors/withMarket' },
}));
type FullProps = ConnectedProps<typeof connector>;
export default connector(VendorChangesList);
